import { ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT } from "./types";


export default {
    [ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT]: async (state, data) => {
        state.weightAdjustment = data
    },
}